import React from "react";
import { Link } from "react-router-dom";
import bedrijven from "../../Components/Lib/Bedrijven/bedrijven";

const KamperenMenu = ({ token, username, isActive, onToggle }) => {

  // Alleen tonen als gebruiker kampeerplaatsen module heeft
  if (username?.bedrijf?.modules?.includes("kampeerplaatsen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "havenmeester") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              {username.bedrijf.soort === "jachthaven" ? (
                <i className="fas fa-anchor"></i>
              ) : (
                <i className="fas fa-campground"></i>
              )}
            </span>
            <span className="menu-text">
              {username.bedrijf.soort === "jachthaven" ? "Jachthaven" : "Kamperen"}
            </span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            {/* Hoofdoverzicht */}
            <div className="menu-item">
              <Link to="/standplaatsen/kampeerplaatsen" className="menu-link">
                <span className="menu-icon">
                  {username.bedrijf.soort === "jachthaven" ? (
                    <i className="fas fa-plug"></i>
                  ) : (
                    <i className="fas fa-caravan"></i>
                  )}
                </span>
                <span className="menu-text">
                  {username.bedrijf.soort === "jachthaven" ? "Stroompunten" : "Kampeerplaatsen"}
                </span>
              </Link>
            </div>


            {/* Categorieën */}
            <div className="menu-item">
              <Link to="/standplaatsen/categorien" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-tags"></i>
                </span>
                <span className="menu-text">Categorieën</span>
              </Link>
            </div>


            {/* Admin functies */}
            {token.role === "admin" && (
              <>
                <div className="menu-divider"></div>
                <div className="menu-item">
                  <Link to="/standplaatsen/kampeerplaatsen/insert" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-plus"></i>
                    </span>
                    <span className="menu-text">
                      {username.bedrijf.soort === "jachthaven" ? "Stroompunt Toevoegen" : "Kampeerplaats Toevoegen"}
                    </span>
                  </Link>
                </div>
                
                <div className="menu-item">
                  <Link to="/standplaatsen/kampeerplaatsen/importeren" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-upload"></i>
                    </span>
                    <span className="menu-text">
                      {username.bedrijf.soort === "jachthaven" ? "Stroompunten Importeren" : "Kampeerplaatsen Importeren"}
                    </span>
                  </Link>
                </div>


                <div className="menu-item">
                  <Link to="/standplaatsen/veldkasten" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-box"></i>
                    </span>
                    <span className="menu-text">Veldkasten</span>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      );
    }
  }
  
  return null;
};

export default KamperenMenu;